import i18n from "@/core/plugins/vue-i18n";

// getter types
export const TOAST_DATA = "toastData";

// action types
export const DISPLAY_TOAST = "displayToast";
export const EXPIRE_TOAST = "expireToast";

// mutation types
const SET_DATA = "setData";
const SET_DISPLAY_TOAST = "setDisplayToast";

export const TOAST_TYPE_ENUM = Object.freeze({
  success: "Success",
  info: "Info",
  warning: "Warning",
  error: "Error"
});

const state = {
  toast: {
    display: false,
    message: i18n.t("General.Messages.NoDataReceived"),
    type: TOAST_TYPE_ENUM.warning
  }
};

const getters = {
  [TOAST_DATA](state) {
    return state.toast;
  }
};

const actions = {
  [DISPLAY_TOAST](context, payload) {
    context.commit(SET_DATA, payload);
    context.commit(SET_DISPLAY_TOAST, true);
  },
  [EXPIRE_TOAST](context) {
    context.commit(SET_DISPLAY_TOAST, false);
  }
};

const mutations = {
  [SET_DISPLAY_TOAST](state, isOpen) {
    state.toast.display = isOpen;
  },
  [SET_DATA](state, data) {
    state.toast.type = data?.type ?? TOAST_TYPE_ENUM.warning;
    state.toast.message =
      data?.message ?? i18n.t("General.Messages.NoDataReceived");
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
